import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Settings from '../components/pages/settings';
import Follower from '../components/pages/follower';
import Search from '../components/pages/search';
import InreplyTo from '../components/pages/inreplyto';
import BlockLists from '../components/pages/blocklists';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {config, settings} from '../config/config';
import Refresh from '@material-ui/icons/Refresh';
import axios from 'axios';
import Alert from './alert';
import Loader from './loader';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import './../App.css';

const styles = theme => ({
  heroUnit: {
    margin: "0 0 15px 0"
  },
  heroContent: {
    maxWidth: 600,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  typography: {
    paddingLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    color: theme.palette.text.secondary
  },
  notification: {
    margin: "10px 0",
    border : "1px solid #dedede",
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    boxShadow: "0px 0px 0px"
  },
  root: {
    flexGrow: 1
  }
});

class CenteredTabs extends Component {

  constructor() {
    super();
    this.alertHandleClose = this.alertHandleClose.bind(this);
    this.refreshAPI = this.refreshAPI.bind(this);
  }

  state = {
    value: 0,
    row: [
      {
        name: "followers/ids",
        remain: -1,
        max: 15,
        reset: "取得中"
      }, {
        name: "search/tweets",
        remain: -1,
        max: 180,
        reset: "取得中"
      }
    ],
    isLoading: false,
    isAlertOpen: false,
    alertErrorMessage: ""
  };

  componentDidMount() {
    this.refreshAPI();
  }

  async refreshAPI() {
    this.setState({isLoading: true});
    try {
      const response = await axios.get(settings.url + "/apiCheck", config);
      if(!response){ return; }
      if(response.data.mes !== "ok"){
        throw response.data.reason;
      }else{
        this.setState({isLoading: false, isAlertOpen: false, alertErrorMessage: "", row:response.data.result});
      }
    } catch (e) {
      this.setState({isLoading: false, isAlertOpen: true, alertErrorMessage: JSON.stringify(e),
      row:[{
        name : "followers/ids",
        remain : "?",
        max : 15,
        reset : "取得失敗"
      },
      {
        name : "search/tweets",
        remain : "?",
        max : 180,
        reset : "取得失敗"
      }]});
    }
  }

  alertHandleClose() {
    this.setState({isAlertOpen: false});
  }

  handleChange = (event, value) => {
    this.setState({value});
  };

  updateApiLimits(newData){
    this.setState({
      row:newData
    })
  }

  render() {
    const {classes} = this.props;
    const {value, row} = this.state;

    return (<div>
      <Paper className={classes.root}>
        <Paper className={classes.paper}>
        <Tabs value={this.state.value} onChange={this.handleChange} indicatorColor="primary" textColor="primary" variant="scrollable"
            scrollButtons="auto">
          <Tab label="フォロワー"/>
          <Tab label="検索"/>
          <Tab label="In-reply-to"/>
          <Tab label="作成されたブロックリスト"/>
          <Tab label="設定"/>
        </Tabs>
        </Paper>
        <Paper className={classes.notification}>
          <Link to="/stats">統計データが見れるようになりました。</Link><br/>
          2020年6月26日をもってクソリプバスターを運用しているサーバーを移転しました。<br/>
          これに伴い、同日以前に生成されたCSVはご利用いただけなくなります。<br/>
          蓄積されたユーザーデータについてもリセット対象となっていますので、なにとぞご承知おきください。<br/>
          本サービスは無償で運営されております。もしお気に召していただけた場合、<a href="https://www.amazon.co.jp/dp/B06X982RQ9/">こちら</a>からmsqkn310@gmail.com宛にAmazonギフト券でご支援を頂けると大変励みになります。よろしくお願いいたします。
        </Paper>
        {value === 0 && <TabContainer><Follower updateApiLimits={this.updateApiLimits.bind(this)}/></TabContainer>}
        {value === 1 && <TabContainer><Search updateApiLimits={this.updateApiLimits.bind(this)}/></TabContainer>}
        {value === 2 && <TabContainer><InreplyTo updateApiLimits={this.updateApiLimits.bind(this)}/></TabContainer>}
        {value === 3 && <TabContainer><BlockLists/></TabContainer>}
        {value === 4 && <TabContainer><Settings/></TabContainer>}
      </Paper>
      <Paper className={classes.root}>
        <div className="scroll">
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>API</TableCell>
                <TableCell align="right">残り</TableCell>
                <TableCell align="right">MAX</TableCell>
                <TableCell align="right">回数復活</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                row.map(row => (<TableRow key={row.name}>
                  <TableCell align="right">{row.name}</TableCell>
                  <TableCell align="right">{row.remain}</TableCell>
                  <TableCell align="right">{row.max}</TableCell>
                  <TableCell align="right">{row.reset}</TableCell>
                </TableRow>))
              }
            </TableBody>
          </Table>
        </div>
        <Grid container={true} style={{
            alignItems: "center",
            padding: "0 20px"
          }} justify="flex-end">
          <Grid item={true}>
            <Loader isVisible={this.state.isLoading}/>
          </Grid>
          <Grid item={true} style={{
              height: "60px",
              display: "flex",
              alignItems: "center"
            }}>
            <Button variant="contained" size="small" color="primary" className={classes.button} onClick={this.refreshAPI} disabled={this.state.isLoading}>
              <Refresh className={classNames(classes.leftIcon, classes.iconSmall)} style={{
                  marginRight: "5px"
                }}/> {this.state.isLoading && <span>お待ち下さい...</span>}
              {!this.state.isLoading && <span>最新の情報を取得</span>}
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Alert open={this.state.isAlertOpen} handleClose={this.alertHandleClose} errorMessage={this.state.alertErrorMessage}/>
    </div>);
  }
}

function TabContainer({children, dir}) {
  return (<Typography component="div" dir={dir} style={{
      padding: 8 * 3
    }}>
    {children}
  </Typography>);
}

CenteredTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CenteredTabs)
